import { sectionHeight, sectionOffsetTop } from "pages/editor/lib/timeline";
import styled from "styled-components";

export const TransitionDropAreasContainer = styled.div`
    position: absolute;
    width: 100%;
    height: ${(props) => sectionHeight(props.layer)}px;
    top: ${(props) => sectionOffsetTop(props.layer)}px;
    pointer-events: none;
    z-index: 20;
`;

export const TransitionDropAreaContainer = styled.div`
    position: absolute;
    height: 100%;
    background: rgb(255, 255, 255);
    top: 0;
    z-index: 1;
    opacity: 0;
    pointer-events: all;
`;
